import { useTranslation } from 'react-i18next';

/**
 * @param {string} purpose
 * @param {'approver' | 'viewer'} role
 *
 * @returns {string}
 */
export function useGetPurposeAction(purpose = '', role) {
    const { t } = useTranslation();

    if (role === 'viewer') {
        return t('ai:purpose.known.yes');
    }

    switch (purpose) {
        case 'notify':
            return t('ai:purpose.known.yes');
        case 'revise':
            return t('ai:purpose.revise.done');
        case 'feedback':
            return t('ai:purpose.feedback.given');
        case 'check':
            return t('ai:purpose.checked.yes');
        case 'assess':
            return t('ai:purpose.assessed.yes');
        case 'approve':
        default:
            return t('ai:purpose.approved.action');
    }
}
